import type { ComponentStyleConfig } from '@chakra-ui/react';

const baseStyle = {
  field: {
    border: '0px solid',
    padding: 0,
    fontSize: 'md',
    fontWeight: 400,
    lineHeight: '22px',
    height: '24px',
    color: 'black.500',
    fontFamily: '"Poppins", sans-serif',
    fontSmoothing: 'antialiased',
    marginTop: 0,
    _placeholder: {
      color: 'neutral.400',
    },
    _focus: {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  element: {
    width: '30px',
    paddingRight: 0,
    paddingLeft: 0,
    marginTop: '3px',
  },
};

const elementLeftVariant = {
  field: {
    paddingLeft: '40px',
    height: '24px',
  },
  element: {
    marginLeft: 0,
    height: '24px',
  },
};

const elementRightVariant = {
  field: {
    paddingRight: '40px',
    height: '24px',
  },
  element: {
    marginRight: '0px',
    height: '24px',
  },
};

export const Input: ComponentStyleConfig = {
  baseStyle,
  variants: {
    'element-left': elementLeftVariant,
    'element-right': elementRightVariant,
  },
  defaultProps: {
    variant: 'unstyled',
  },
};
